import { loadStripe } from "@stripe/stripe-js";

const stripeConfig = loadStripe(process.env.REACT_APP_PUB_STRIPE_KEY!);

export default stripeConfig;
